// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__396h0","productName":"Table_productName__1iT5K"};